import type { OfficialGameweekPoints } from '../api.ts';

/** The gameweek total shown to a manager, and whether it's this app's own
 * estimate rather than FPL's own figure. */
export interface GameweekPoints {
  points: number | null;
  isEstimate: boolean;
}

/**
 * The one place that decides a squad's gameweek total (T-113). Before this,
 * `SquadContextBar` and `ThisWeek` each resolved it their own way — one
 * preferred `official`, the other never looked at it at all — and the two
 * disagreed on screen at the same moment. Both now call this.
 *
 * FPL's own figure already accounts for auto-substitutions, which
 * `estimateSquadPoints` deliberately doesn't model — that's a legitimate,
 * documented difference once a gameweek finishes, not a bug to reconcile —
 * so `official` is preferred whenever it's there, and `estimated` is the
 * fallback rather than something to average or cross-check against it.
 */
export function resolveGameweekPoints(
  official: OfficialGameweekPoints | null,
  estimated: number | null,
): GameweekPoints {
  if (official !== null) return { points: official.points, isEstimate: false };
  return { points: estimated, isEstimate: true };
}
